import { render, staticRenderFns } from "./ImportFiles.vue?vue&type=template&id=0927aefc"
import script from "./ImportFiles.vue?vue&type=script&lang=js"
export * from "./ImportFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports